import React from 'react';
import { SlideContainer } from './SlideContainer';
import slideTotemImg from '../assets/SlideTotem2.jpg';
import { ISlidePropostaData } from '../interface';

export interface SlideTotemProps {
  data?: ISlidePropostaData;
  scale?: number;
}

const DEFAULT_TEXTO_TOTEM = `TOTEM INTERATIVO DE LED 32 POLEGADAS COM SUPORTE.\n\nACESSO INCLUSO AOS APLICATIVOS DASHBOARD E GOVFÁCIL.`;

export const SlideTotem: React.FC<SlideTotemProps> = ({ data, scale = 1 }) => {
  const textoExibicao = (data?.texto_dispositivo || data?.texto_dispositivo_padrao || DEFAULT_TEXTO_TOTEM).toUpperCase();

  return (
    <SlideContainer 
      showFooterLogo={false} 
      showWaves={false} 
      noPadding={true}
      backgroundImage={slideTotemImg}
      scale={scale}
      data={data}
    >
      <div style={{ position: 'relative', width: '100%', height: '100%' }}>
        <div
          style={{
            position: 'absolute',
            top: '25%',
            left: '755px',
            width: '46%',
            color: '#0077b6',
            fontWeight: 900,
            fontSize: 38,
            lineHeight: 1.35,
            letterSpacing: 0.5,
            textTransform: 'uppercase',
            whiteSpace: 'pre-line',
          }}
        >
          {textoExibicao}
        </div>
      </div>
    </SlideContainer>
  );
};